import type { GetVehicleColorsResponseDTO } from '~/dto/Assegurou/vehicleColors';
import apiAssegurouAuto from '~/services/apiAssegurouAuto';

export async function getVehicleColorsUseCase(): Promise<Select.Option[]> {
  try {
    const response = await apiAssegurouAuto.get<GetVehicleColorsResponseDTO>(
      `/auto/getListaCorVeiculo`
    );

    return response.data.resultData.map((item) => ({
      label: item.descricao,
      value: String(item.id),
    }));
  } catch (error) {
    return [];
  }
}
